export const defaultScopeId = "v3.maintenance.data";

export const BACKUP_REQUESTED = "DATA/BACKUP_REQUESTED";
export const BACKUP_SUCCEEDED = "DATA/BACKUP_SUCCEEDED";
export const BACKUP_FAILED = "DATA/BACKUP_FAILED";
export const RESTORE_REQUESTED = "DATA/RESTORE_REQUESTED";
export const RESTORE_SUCCEEDED = "DATA/RESTORE_SUCCEEDED";
export const RESTORE_FAILED = "DATA/RESTORE_FAILED";
export const RESET_REQUESTED = "DATA/RESET_REQUESTED";
export const RESET_SUCCEEDED = "DATA/RESET_SUCCEEDED";
export const RESET_FAILED = "DATA/RESET_FAILED";
export const UPDATE_AI_REQUESTED = "DATA/UPDATE_AI_REQUESTED";
export const UPDATE_AI_SUCCEEDED = "DATA/UPDATE_AI_SUCCEEDED";
export const UPDATE_AI_PROGRESSED = "DATA/UPDATE_AI_PROGRESSED";
export const UPDATE_AI_FAILED = "DATA/UPDATE_AI_FAILED";

// eslint-disable-next-line max-statements
export default (
  state = {
    errors: [],
    loading: false,
    loggedIn: false,
    aiEmbeddingsProgress: null,
  },
  { type, data }
) => {
  switch (type) {
  case BACKUP_REQUESTED: {
    state.loading = true;
    return state;
  }
  case BACKUP_SUCCEEDED: {
    state.loggedIn = true;
    state.loading = false;
    return state;
  }
  case BACKUP_FAILED: {
    state.loggedIn = false;
    state.loading = false;
    state.errors.push(data);
    return state;
  }
  case RESTORE_REQUESTED: {
    state.loading = true;
    return state;
  }
  case RESTORE_SUCCEEDED: {
    state.loggedIn = false;
    state.loading = false;
    return state;
  }
  case RESTORE_FAILED: {
    state.loading = false;
    state.errors.push(data);
    return state;
  }
  case RESET_REQUESTED: {
    state.loading = true;
    return state;
  }
  case RESET_SUCCEEDED: {
    state.loggedIn = false;
    state.loading = false;
    return state;
  }
  case UPDATE_AI_REQUESTED: {
    state.loading = true;
    state.aiEmbeddingsProgress = 0;
    state.aiEmbeddingsPhase = "";
    if (data) {
      if (data.fields) {
        state.fields = data.fields;
      }
      if (data.clearBeforeResync) {
        state.clearBeforeResync = data.clearBeforeResync;
      }
    }
    return state;
  }
  case UPDATE_AI_PROGRESSED: {
    state.loading = true;
    const progressInfo = data || {};
    state.aiEmbeddingsProgress = progressInfo.progress || 0;
    state.aiEmbeddingsPhase = progressInfo.phase || "";
    return state;
  }
  case UPDATE_AI_SUCCEEDED: {
    state.loggedIn = false;
    state.loading = false;
    state.aiEmbeddingsProgress = null;
    state.aiEmbeddingsPhase = "";
    return state;
  }
  case RESET_FAILED: {
    state.loading = false;
    state.errors.push(data);
    return state;
  }
  default:
    return state;
  }
};

export const backupRequested = (resolve, reject) => ({ type: BACKUP_REQUESTED, resolve, reject });
export const backupSucceeded = data => ({ type: BACKUP_SUCCEEDED, data });
export const backupFailed = data => ({ type: BACKUP_FAILED, data });
export const restoreRequested = (resolve, reject) => ({ type: RESTORE_REQUESTED, resolve, reject });
export const restoreSucceeded = data => ({ type: RESTORE_SUCCEEDED, data });
export const restoreFailed = data => ({ type: RESTORE_FAILED, data });
export const resetRequested = (resolve, reject) => ({ type: RESET_REQUESTED, resolve, reject });
export const resetSucceeded = data => ({ type: RESET_SUCCEEDED, data });
export const resetFailed = data => ({ type: RESET_FAILED, data });
export const updateAIRequested = (data, resolve, reject) => ({ type: UPDATE_AI_REQUESTED, data, resolve, reject });
export const updateAISucceeded = data => ({ type: UPDATE_AI_SUCCEEDED, data });
export const updateAIProgressed = data => ({ type: UPDATE_AI_PROGRESSED, data });
export const updateAIFailed = data => ({ type: UPDATE_AI_FAILED, data });
